import React from 'react';
import { Box, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { RoutineActivityRecurring } from '@demind-inc/core';
import clsx from 'clsx';
import './RoutineRecurringSelector.scss';
import { DAYS_OF_WEEK, getRecurringDayFromDate } from '../recurrence.helpers';
import { useTranslation } from 'react-i18next';
import { getWeekdayLabels } from '../../../DataView/i18n';

interface RoutineRecurringSelectorProps {
  recurring: RoutineActivityRecurring;
  selectedDate?: Dayjs;
  onDaySelect: (day: keyof RoutineActivityRecurring) => void;
  className?: string;
  hasSmallContainer?: boolean;
  disabled?: boolean;
}

const RoutineRecurringSelector: React.FC<RoutineRecurringSelectorProps> = ({
  recurring,
  selectedDate,
  onDaySelect,
  className,
  hasSmallContainer = false,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const weekdayLabels = getWeekdayLabels(t, 'narrow');
  const selectedDayOfWeek = selectedDate ? getRecurringDayFromDate(selectedDate) : undefined;

  return (
    <div className={clsx('routine-recurring-selector', className)}>
      <div
        className={clsx('routine-recurring-selector__days-container', {
          'routine-recurring-selector__days-container--small': hasSmallContainer,
        })}
      >
        {DAYS_OF_WEEK.map(({ key }, index) => (
          <div
            key={key}
            onClick={() => !disabled && onDaySelect(key)}
            className={clsx('routine-recurring-selector__day-button', {
              'routine-recurring-selector__day-button--selected': recurring[key]?.enabled,
              'routine-recurring-selector__day-button--today': selectedDayOfWeek === key,
              'routine-recurring-selector__day-button--small': hasSmallContainer,
              'routine-recurring-selector__day-button--disabled': disabled,
            })}
          >
            <Typography
              className={clsx('routine-recurring-selector__day-text', {
                'routine-recurring-selector__day-text--selected': recurring[key]?.enabled,
              })}
              variant={hasSmallContainer ? 'subtitle1' : 'body1'}
            >
              {weekdayLabels[index]}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoutineRecurringSelector;
